<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <contact-person-form
          @submit="submit"
          :init-contact-person="{}"
          :val-errors="valErrors"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import ContactPersonForm from './contact-person-form'
export default {
  components: { ContactPersonForm },
  data () {
    return {
      valErrors: []
    }
  },
  methods: {
    async submit (contactPerson) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post(`/suppliers/${this.$route.params.sid}/contact_people`, contactPerson).then(({ data }) => {
        this.$notify({
          message: 'Ansprechpartner erfolgreich erstellt.',
          type: 'success'
        })
        this.redirectBack('/suppliers')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$http.get(`/suppliers/${vm.$route.params.sid}`).catch(err => {
        console.log(err)
        vm.$router.push('/suppliers')
      })
    })
  }
}
</script>

<style>
</style>
